if $ == undefined
  $ = jQuery

Modernizr.load()

window.merge_objects = (obj1,obj2)->
  obj3 = {}
  for attrname of obj1
    obj3[attrname] = obj1[attrname]
  for attrname of obj2
    obj3[attrname] = obj2[attrname]
  obj3

window.params_from_url = (url)->
  params = {}
  splitted_url = url.split('#')
  splitted_url = splitted_url[0].split('?')
  return params if splitted_url.length == 1 or splitted_url[1] == ''
  string_params = splitted_url[1]
  if string_params.match(/&/)
    string_params = string_params.substring(1, string_params.length) if string_params.match(/^&/)
    string_params = string_params.replace(/&/g,"=")
  split_params_get = string_params.split("=")
  $.each split_params_get, (i,param)->
    if not ((i/2)+"").match(/\./) or (i/2)==0
      if param.match(/%5B%5D/)
        _param = param.replace('%5B%5D','')
        params[_param] ||= []
        params[_param].push split_params_get[i+1]
      else if param.match(/\[\]/)
        _param = param.replace('[]','')
        params[_param] ||= []
        params[_param].push split_params_get[i+1]
      else
        params[param] = split_params_get[i+1]
    else return
  params

window.add_params_to_url = (url, params)->
  final_url = null
  splitted_url = url.split('?')
  params_url = params_from_url(url)
  if typeof params == 'object'
    params_url = merge_objects(params_url, params)
  else if typeof params == 'string'
    _params = params_from_url("?"+params)
    params_url = merge_objects(params_url, _params)
  all_params = []
  $.each params_url, (k,v)->
    if typeof v == 'object'
      $.each v, (k2,v2)->
        all_params.push k+"[]="+v2
    else
      all_params.push k+"="+v
  if all_params.length > 0
    new_url = splitted_url[0]+"?"+all_params.join('&')
  else
    new_url = splitted_url[0]
  new_url

window.remove_params_from_url = (url, params)->
  base_url = url.split('?')[0]
  url_params = params_from_url(url)
  $.each params, (i,param)->
    delete url_params[param]
  add_params_to_url(base_url, url_params)

scrollTo = (element, to, duration)->
  return if duration <= 0
  difference = to - element.scrollTop()
  perTick = difference / duration * 2
  setTimeout ->
    element.scrollTop(element.scrollTop() + perTick)
    scrollTo(element, to, duration - 2)
  , 10

checkFormAppointment = (form)->
  ok = true
  name = if form then form.find(".appointment-name") else $("#appointment-name")
  surname = if form then form.find(".appointment-surname") else $("#appointment-surname")
  email = if form then form.find(".appointment-email") else $("#appointment-email")
  email_confirmation = if form then form.find(".appointment-email-confirmation") else $("#appointment-email-confirmation")
  mobile_phone = if form then form.find(".appointment-mobile-phone") else $("#appointment-mobile-phone")
  trattamento = if form then form.find("#trattamento2") else $("#trattamento2")
  if ta_validator.presence(email_confirmation)
    ok = false
  unless ta_validator.presence(name)
    msg = if $("html").attr('lang') != 'it-IT' then "Can't be blank" else "Devi compilare questo campo"
    ta_validator.addError name, msg
    ok = false
  else
    ta_validator.removeError name
  unless ta_validator.presence(surname)
    msg = if $("html").attr('lang') != 'it-IT' then "Can't be blank" else "Devi compilare questo campo"
    ta_validator.addError surname, msg
    ok = false
  else
    ta_validator.removeError surname
  unless ta_validator.format(email,ta_validator.email_regexp)
    msg = if $("html").attr('lang') != 'it-IT' then "Email is invalid" else "Email non vailda"
    ta_validator.addError email, msg
    ok = false
  else
    ta_validator.removeError email
  if mobile_phone.length > 0
    unless ta_validator.presence(mobile_phone)
      msg = if $("html").attr('lang') != 'it-IT' then "Can't be blank" else "Devi compilare questo campo"
      ta_validator.addError mobile_phone, msg
      ok = false
    else
      ta_validator.removeError mobile_phone
  unless trattamento.is(':checked')
    msg = if $("html").attr('lang') != 'it-IT' then "Check this box" else "Spunta questa casella"
    ta_validator.addError trattamento, msg
    ok = false
  else
    ta_validator.removeError trattamento
  return ok

aCookie = document.cookie.match(/\b_amta=([^;]*)/)
bCookie = document.cookie.match(/\b_amta_ok=([^;]*)/)
cCookie = document.cookie.match(/\b_irf=([^;]*)/)
dCookie = document.cookie.match(/\b_amtt=([^;]*)/)
eCookie = document.cookie.match(/\b_amtc=([^;]*)/)
fCookie = document.cookie.match(/\b_amtc_ok=([^;]*)/)
gCookie = document.cookie.match(/\b_fb_box=([^;]*)/)

$ ->
  # Autocomplete per chrome (senza $.browser, rimosso in jQuery 3)
  if /Chrome/.test(navigator.userAgent) and !/Edge|Edg/.test(navigator.userAgent)
    $('input[autocomplete="off"]').each ->
      $(@).attr("autocomplete", "chromenonrompere")

  $("#line-consulenza").on "click", (event)->
    event.preventDefault()
    window.location = '/contacts/'

# Like di Facebook con manona: spostato nel plugin TeamArtist Lead (acchiappini.js)

window.register_event = (cat,act,label,value)->
  if _gaq?
    _gaq.push(['_trackEvent', cat, act, label,value]);
  if woopraTracker?
    woopraTracker.pushEvent({name:cat,action:act});

window.tracker = ()->
  $("form").each ()->
    form = $(this)
    if typeof form.data().trackerCategory != "undefined"
      form.on "submit", ()->
        cat = if typeof form.data().trackerCategory != "undefined" then form.data().trackerCategory else ""
        act = if typeof form.data().trackerAction != "undefined" then form.data().trackerAction else ""
        label = if typeof form.data().trackerLabel != "undefined" then form.data().trackerLabel else ""
        value = if typeof form.data().trackerValue != "undefined" then form.data().trackerValue else ""
        register_event cat,act,label,value

window.show_overlay = ()->
  $("#overlay").show()
window.hide_overlay = ()->
  $("#overlay").hide()

window.fix_admin_bar_position = ->
  if $("#wpadminbar").length == 1
    $("#wpadminbar").hide()
    # w_window = $(window).width()
    # if w_window < 783
    #   pTop = "46px"
    # else
    #   pTop = "32px"
    # $("#content-page").css "paddingTop", pTop
    # if $("#scroll-header").css("position") == "fixed"
    #   $("#scroll-header").css "top", pTop
    # else
    #   $("#scroll-header").css "top", 0

window.loadArticle = (pageNumber)->
  window.ajax_call_queue.push pageNumber
  $("#content-posts .loader").show()
  s = if window.params_get? and window.params_get.s? then window.params_get.s else ""
  _data = {
    action: 'infinite_scroll',
    page_no: pageNumber,
    s: s
  }
  _data['a'] = $('h1.title-search').data('author') if $('h1.title-search').length > 0 and $('h1.title-search').data('author') != ''
  _data['c'] = $('h1.title-search').data('cat') if $('h1.title-search').length > 0 and $('h1.title-search').data('cat') != ''
  _data['t'] = $('h1.title-search').data('tag') if $('h1.title-search').length > 0 and $('h1.title-search').data('tag') != ''
  $.ajax
    url: "/blog/wp-admin/admin-ajax.php"
    type: 'POST'
    data: _data
    success: (html)->
      if (html or "").toString().trim() == ""
        window.end_posts = true
      else
        $("#content-posts > .loader").before html
        reloadPaginator(pageNumber,s)
        window.loaded_ajax_page.push pageNumber
    complete: ->
      $("#content-posts .loader").hide()
      window.ajax_call_queue.splice $.inArray(pageNumber, window.ajax_call_queue), 1
  return false;

window.reloadPaginator = (pageNumber,s)->
  uri = document.location.href
  total_pages = $("#content-posts").data("total")
  _data = {
    action: 'reload_paginator',
    page_no: pageNumber,
    s: s,
    uri: uri,
    suggest_total_pages: total_pages
  }
  _data['a'] = $('h1.title-search').data('author') if $('h1.title-search').length > 0 and $('h1.title-search').data('author') != ''
  _data['c'] = $('h1.title-search').data('cat') if $('h1.title-search').length > 0 and $('h1.title-search').data('cat') != ''
  _data['t'] = $('h1.title-search').data('tag') if $('h1.title-search').length > 0 and $('h1.title-search').data('tag') != ''
  $.ajax
    url: "/blog/wp-admin/admin-ajax.php"
    type: 'POST'
    data: _data
    success: (html)->
      if (html or "").toString().trim() == ""
        window.end_posts = true
      else
        $("#wrap-pagination").html html
  return false;

window.move_submenu = ->
  w_window = $(window).width()
  menu_top = $("#menu-top")
  $("#header .children").each ->
    return if $(@).attr("id") == "menu-ass"
    if w_window < 921
      menu_top.after $(@) if $("#menu-top + ##{$(@).attr("id")}").length == 0
    else
      link = $("#link-#{$(@).attr("id")}")
      link.parent().append $(@) if $("#link-#{$(@).attr("id")} + ##{$(@).attr("id")}").length == 0

window.add_close_submenu = (menu_name)->
  menu = $("##{menu_name}")
  if $(window).width() < 921
    menu.prepend "<li id='close-#{menu_name}' class='close-submenu' rel='link-#{menu_name}'><a href='#'>Chiudi</a></li>" if $("#close-#{menu_name}").length == 0
  else
    $("#close-#{menu_name}").remove()

window.close_submenus = (parent=false, animation=true)->
  $("#header ul.children:visible").each ->
    if animation
      $(@).slideUp(250)
    else
      $(@).hide()
  if parent and $(window).width() < 920 and $('#menu-top').is(':visible')
    $("#menu-top-small").trigger "click"

# Rimosso: related posts ora in markup duplicato (sidebar + content-sidebar-posts), show/hide via CSS – fix CLS
# window.move_block_posts eliminato

# Rimosso: search/consulenza ora in markup duplicato (header), show/hide via CSS – fix CLS
window.move_search_and_consulenza = ->

# Genera un object con i parametri in get - Object {chiave: "valore", chiave: "valore"}
if window.location.search != ""
  window.params_get = {}
  string_params_get = window.location.search.replace("?","")
  if string_params_get.match(/&/)
    string_params_get = string_params_get.replace(/&/g,"=")
  split_params_get = string_params_get.split("=")
  $.each split_params_get, (i,param)->
    if not ((i/2)+"").match(/\./) or (i/2)==0
      window.params_get[param] = split_params_get[i+1]
    else return

window.checkFormContacts = ()->
  ok = true
  codice = $("#zd_codice")
  name = $("#account_name")
  surname = $("#account_surname")
  email = $("#zd_email")
  subject = $("#zd_subject")
  description = $("#zd_description")
  trattamento = $("#trattamento2")
  zd_name = $("#zd_name")
  unless ta_validator.presence(codice)
    ta_validator.addError codice, "Devi compilare questo campo"
    ok = false
  else
    ta_validator.removeError codice
  unless ta_validator.presence(name)
    ta_validator.addError name, "Devi compilare questo campo"
    ok = false
  else
    ta_validator.removeError name
    zd_name.val "#{name} #{surname}"
  unless ta_validator.presence(surname)
    ta_validator.addError surname, "Devi compilare questo campo"
    ok = false
  else
    ta_validator.removeError surname
    zd_name.val "#{name.val()} #{surname.val()}"
  unless ta_validator.format(email,ta_validator.email_regexp)
    ta_validator.addError email, "Email non vailda"
    ok = false
  else
    ta_validator.removeError email
  unless ta_validator.presence(subject)
    ta_validator.addError subject, "Devi compilare questo campo"
    ok = false
  else
    ta_validator.removeError subject
  unless ta_validator.presence(description)
    ta_validator.addError description, "Devi compilare questo campo"
    ok = false
  else
    ta_validator.removeError description
  unless trattamento.is(':checked')
    ta_validator.addError trattamento, "Spunta questa casella"
    ok = false
  else
    ta_validator.removeError trattamento
  return ok

sticky_footer = ->
  w_window = $(window).width()
  $('#box-footer').removeAttr 'style'
  $('#content-page').removeAttr 'style'
  if w_window > 500
    h = $('#box-footer').height()
    $('#box-footer').css
      marginTop: "-#{h}px"
    $('#content-page').css
      paddingBottom: "#{h}px"

submitIubendaForm = (j_form)->
  subject_id = j_form.find("input[data-cons-id]").val()
  _iub.cons.submit
    form:
      selector: j_form[0] # il selettore del form da cui rilevare i dati
    consent:
      subject:
        id: subject_id
      legal_notices: [
        "identifier": "privacy_policy"
        "version": "2"
      ]
  .success (response)->
    # callback success
    console.log 'Success iubenda'
    console.log arguments
    $.ajax
      url: '/wp-content/plugins/request_api_demo.php'
      type: 'POST'
      data:
        api_url: window.demo_url+"api/iubenda/update_subject"
        email: subject_id
        email_confirmation: ''
      complete: ->
        console.log arguments
  .fail (response)->
    # callback error (jQXHR.error deprecato, usare .fail)
    console.log 'Error iubenda'
    console.log arguments

$ ->

  if $(".arrow-bounce").length == 1
    setTimeout ->
      $(".arrow-bounce").show()
    , 2200

  w_window = $(window).width()

  window.ajax_call_queue = []
  window.wait_ajax_call = []
  window.loaded_ajax_page = []
  window.end_posts = false

  fix_admin_bar_position()

  move_submenu()

  # Fix placeholder per IE
  $("input[placeholder]").each ->
    el = $(@)
    default_val = el.attr "placeholder"
    unless Modernizr.input.placeholder
      el.on "focus", ()->
        if $(this).val() == default_val
          $(this).val ""
      el.on "blur", ()->
        if $(this).val() == ""
          $(this).val default_val
    else
      el.val "" if el.val() == default_val

  # Submit form di ricerca (desktop in sidebar + mobile in #wrapper)
  $("#search-bar .ion-search, .search-bar-mobile .ion-search").on "click", ->
    $(@).parents("form").submit()

  # Azzeramento form per i commenti
  if $("#commentform").length > 0
    $("#commentform").find("input[type=text]").val ""
    $("#commentform").find("input[type=text]").attr "value", ""
    $("#commentform").find("textarea").val ""
    $("#commentform").find("textarea").attr "value", ""

  $('.comment-reply-link').on 'click', (event)->
    event.preventDefault()
    comment_id = parseInt($(@).parents('.comment-body').attr('id').replace('div-comment-',''), 10)
    $('#demo_commentform input[name="comment[comment_parent_id]"]').val(comment_id)
    $('html, body').scrollTop($('#respond').offset().top-65)

  $("#menu-top-small").on "click", ->
    close_submenus()
    menu = $("#menu-top")
    if menu.is(":visible")
      menu.slideUp(250)
    else
      menu.slideDown(250)

  $('.open-submenu').on "click", (event)->
    event.preventDefault();
    child = $("##{$(@).attr("rel")}")
    if $(window).width() < 921
      header_width = $("#header").outerWidth()
      child.css("width", "#{header_width}px")
      $("#menu-top-small").trigger "click"
    else
      _w = if child.attr('id') == 'menu-software' then '200px' else '190px'
      _w = '310px' if child.attr('id') == 'menu-blog'
      child.css("width", _w)
    add_close_submenu($(@).attr("rel"))
    close_submenus()
    if child.is(":visible")
      child.slideUp(250)
    else
      child.slideDown(250)

  # Ricalcolo dimensioni sottomenu Associazioni
  header_width = $("#header").outerWidth()
  $("#menu-ass").css("width", "#{header_width}px")
  $("#link-menu-ass").on "click", (event)->
    event.preventDefault()
    menu_ass = $("#menu-ass")
    if menu_ass.length > 0
      unless menu_ass.is(":visible")
        close_submenus()
        menu_ass.slideDown(250)
        if $(window).width() <= 790
          $("body").css("overflow", "hidden")
      else
        menu_ass.slideUp(250)
        $("body").css("overflow", "initial")

  # Chiusura sottomenu Associazioni
  $(document).on "click", ".close-submenu a", (event)->
    event.preventDefault()
    link_trigger = $(@).parent().attr("rel")
    if link_trigger? and $("##{link_trigger}").length > 0
      $("##{link_trigger}").trigger "click"

  # Paginazione ajax
  if $("body").hasClass("home") or $("body").hasClass("search") or $("body").hasClass("author") or $("body").hasClass("archive")
    page = parseInt($("#content-posts").data("page"), 10) + 1
    max_num_pages = parseInt $("#content-posts").data("total"), 10
    $(window).scroll ->
      if $(window).scrollTop() == $(document).height() - $(window).height()
        if $.inArray(page, window.loaded_ajax_page) == -1
          if window.ajax_call_queue.length == 0
            if window.end_posts == true or page > max_num_pages
              return false
            else
              loadArticle(page)
            page++
          else
            window.wait_ajax_call[page] = setInterval ->
              if window.ajax_call_queue.length == 0
                clearInterval window.wait_ajax_call[page]
                window.wait_ajax_call.splice $.inArray(window.wait_ajax_call[page], window.wait_ajax_call), 1
                if window.end_posts == true or page > max_num_pages
                  return false
                else
                  loadArticle(page)
                page++
            , 1000

  # torno al top della pagina
  $("#scroll-top").on "click", (event)->
    el = if navigator.userAgent.toLowerCase().indexOf('firefox') != -1 or navigator.userAgent.toLowerCase().indexOf('chrome') != -1 then $('html') else $('body')
    event.preventDefault()
    scrollTo el, 0, 100
    # scroll_time = Math.ceil($(document).height()/5)
    # $("body").animate {scrollTop: 0}, scroll_time

  # # Menu per prontuario
  # $("#submenu a, #handbooks").on "click", (event)->
  #   event.preventDefault()
  #   if $(@).attr("id") == "handbooks"
  #     $("#menu-top").slideUp(250)
  #   $("#menu-prontuario").show()
  #   $("#menu-prontuario").animate
  #     height: "100%"
  #     width: "100%"
  #     opacity: 1
  #     left: 0
  #     top: 0
  #   , "slow"
  #   $("body").css "overflow", "hidden"

  # $("#close-menu-prontuario").on "click", (event)->
  #   event.preventDefault()
  #   $("#menu-prontuario").animate
  #     height: "80%"
  #     width: "80%"
  #     opacity: 0
  #     left: "10%"
  #     top: "10%"
  #   , "slow", ->
  #     $("#menu-prontuario").hide()
  #     $("body").css "overflow", "initial"

  # $("#menu-prontuario:not(.new-menu) .col ul.menu > li ul").hover ->
  #   $(@).parent().addClass "hover"
  # , ->
  #   $(@).parent().removeClass "hover"

  # if $(window).width() <= 750 and not $('#menu-prontuario').hasClass('new-menu')
  #   $("#menu-prontuario .col ul.menu > li > a").on "click", (event)->
  #     parent = $(@).parent()
  #     if parent.find("ul").css("maxHeight") == "0px"
  #       $(@).blur()
  #       $("#menu-prontuario .col ul.menu").removeClass "small-menu"
  #       $("#back-menu-prontuario").css {display: "inline-block"}
  #       $(".wrapper-menus").css {top: "137px"}
  #       event.preventDefault()
  #       content = $(@).parents(".wrapper-menus")
  #       content.find("h5").hide()
  #       content.find("ul.menu > li").hide()
  #       parent.parent().addClass("small-menu")
  #       parent.show()
  #       parent.find("ul").css {maxHeight: "1000px"}

  #   $("#back-menu-prontuario").on "click", (event)->
  #     event.preventDefault()
  #     $(".wrapper-menus ul.menu > li ul").removeAttr "style"
  #     setTimeout ->
  #       $("#menu-prontuario .col ul.menu").removeClass "small-menu"
  #       $(".wrapper-menus ul.menu > li").removeAttr "style"
  #       $(".wrapper-menus h5").removeAttr "style"
  #       $(".wrapper-menus").removeAttr "style"
  #       $("#back-menu-prontuario").hide()
  #     , 1000
  # # Fine menu prontuario

  # # Nuovo menu prontuario
  # if $('#menu-prontuario').hasClass('new-menu')
  #   window.defaultHProntuario = $('#menu-prontuario .col').length * 29
  #   $('#placeholder-tags').css 'height', window.defaultHProntuario
  #   $('#placeholder-posts').css 'height', window.defaultHProntuario

  #   $(document).on 'click', '#menu-prontuario h5 a', (event)->
  #     event.preventDefault()
  #     $('.wrapper-menus')[0].scrollTop = 0
  #     $('#menu-prontuario h5 a').removeClass('active')
  #     if $(window).width() <= 570
  #       $('#wrap-cols').hide()
  #       $('#placeholder-tags').show()
  #     else
  #       $(@).addClass('active')
  #       $('#placeholder-posts').css 'height', window.defaultHProntuario
  #     $('#placeholder-tags').html $(@).parent().next().clone()
  #     $('#placeholder-tags').css 'height', ''
  #     $('#placeholder-posts').empty()

  #   $(document).on 'click', '#placeholder-tags a', (event)->
  #     unless $(@).hasClass('view-all')
  #       event.preventDefault()
  #       $('.wrapper-menus')[0].scrollTop = 0
  #       $('#placeholder-tags a').removeClass('active')
  #       if $(window).width() <= 570
  #         $('#placeholder-tags').hide()
  #         $('#placeholder-posts').show()
  #       else
  #         $(@).addClass('active')
  #       $('#placeholder-posts').html $(@).next().clone()
  #       $('#placeholder-posts').css 'height', ''
  #       if $(window).width() > 570 and $('#placeholder-tags').height() < $('#placeholder-posts').height()
  #         $('#placeholder-tags').css 'height', $('#placeholder-posts').height()
  #       else
  #         $('#placeholder-tags').css 'height', ''

  #   $(document).on 'click', '#menu-prontuario li.close a', (event)->
  #     event.preventDefault()
  #     if $(@).parents('#placeholder-tags').length == 1
  #       $('#wrap-cols').show()
  #       $('#placeholder-tags').hide()
  #     else if $(@).parents('#placeholder-posts').length == 1
  #       $('#placeholder-tags').show()
  #       $('#placeholder-posts').hide()
  # # Fine Nuovo menu prontuario

  # Submit form di ricerca nel menu del prontuario
  $("#menu-prontuario form .ion-search").on "click", ->
    $(@).parents("form").submit()

  # Pagina indice del blog
  $('#indice-blog #menu-prontuario.new-menu .col h5 a').on 'click', (event)->
    event.preventDefault()
    $('#menu-prontuario h5 a').removeClass('active')
    if $(window).width() <= 570
      $('#wrap-cols').hide()
      $('#placeholder-tags').show()
    else
      $(@).addClass('active')
    $('#placeholder-tags').html $(@).parent().next().clone()
    $('#placeholder-posts').empty()

  $(document).on 'click', '#placeholder-tags a', (event)->
    unless $(@).hasClass('view-all')
      event.preventDefault()
      $('#placeholder-tags a').removeClass('active')
      if $(window).width() <= 570
        $('#placeholder-tags').hide()
        $('#placeholder-posts').show()
      else
        $(@).addClass('active')
      $('#placeholder-posts').html $(@).next().clone()

  $(document).on 'click', '#menu-prontuario li.close a', (event)->
    event.preventDefault()
    if $(@).parents('#placeholder-tags').length == 1
      $('#wrap-cols').show()
      $('#placeholder-tags').hide()
    else if $(@).parents('#placeholder-posts').length == 1
      $('#placeholder-tags').show()
      $('#placeholder-posts').hide()

  # $(".subscribe-blog").hover ->
  #   $("#subscribe-box > div").css {borderColor: "#FF9226"}
  #   $("#subscribe-box span.line").css {backgroundColor: "#FF9226"}
  # , ->
  #   $("#subscribe-box > div").css {borderColor: "#F27800"}
  #   $("#subscribe-box span.line").css {backgroundColor: "#F27800"}

  # Apertura box iscrizione al blog
  $(".subscribe-blog").on "click", (event)->
    event.preventDefault()
    $("#subscribe-box").animate
      height: 'toggle'

  # Chiusura box iscrizione al blog
  $("#subscribe-box .ion-close").on "click", (event)->
    event.preventDefault()
    $("#subscribe-box").animate
      height: 'toggle'

  # Submit per iscriversi al Blog
  $("#form-newsletter").on "submit", (event)->
    email = $(this).find("#email")
    if !ta_validator.email_regexp.test(email.val())
      email.addClass "error"
      event.preventDefault()
    else
      email.removeClass "error"

  if $("#page-consulenza").length > 0
    if params_get? and params_get.error == "true"
      alert "Si è verificato un errore durante l'invio del messaggio."
    if params_get? and params_get.send == "true"
      alert "La tua richiesta è stata inviata correttamente e a breve riceverai una mail di riepilogo.\rRiceverai risposta entro 24 h (lavorative) per l'80% dei quesiti e 48 h (lavorative) per i quesiti più spinosi (legati di solito a studio di documenti integrativi del cliente)."
    # Form invio zendesk consulenza
    $("#zd-form").children("input[type=text]").on "focusout", ()->
      el_input = $(@)
      if el_input.attr("id") == "zd_email" and !ta_validator.format(el_input,ta_validator.email_regexp)
        ta_validator.addError el_input, "Email non vailda"
      else
        unless ta_validator.presence(el_input)
          ta_validator.addError el_input, "Devi compilare questo campo"
        else
          ta_validator.removeError el_input

    $("#zd-form").children("textarea").on "focusout", ()->
      el_input = $(@)
      unless ta_validator.presence(el_input)
        ta_validator.addError el_input, "Devi compilare questo campo"
      else
          ta_validator.removeError el_input

    $("#zd-form").on "submit", (event)->
      if not checkFormContacts()
        event.preventDefault()
        return false
      else
        submitIubendaForm($(@)) if $(@).hasClass('iubenda')
    #  Fine form invio zendesk consulenza

  # Sticky footer
  sticky_footer()

  # Check form per richiedere appuntamento
  $('#hidden-zd-form').on 'submit', (event)->
    event.preventDefault()

  $(".appointment-form").on "submit", (event)->
    appointment_form = $(@)
    if not checkFormAppointment(appointment_form)
      event.preventDefault()
    else
      unless appointment_form.data().sendZendesk == true
        event.preventDefault()
        if $('html').data().env == 'developmentttt' # NOTE: Se sono in locale skippo l'invio dello zendesk
          appointment_form.data().sendZendesk = true
          appointment_form.trigger 'submit'
        else
          $('#overlay').show()
          submitIubendaForm(appointment_form) if appointment_form.hasClass('iubenda')
          zd_form = $('#hidden-zd-form')
          name = appointment_form.find('.appointment-name').val()
          surname = appointment_form.find('.appointment-surname').val()
          email = appointment_form.find('.appointment-email').val()
          phone = if appointment_form.find('.appointment-mobile-phone').length > 0 then appointment_form.find('.appointment-mobile-phone').val() else ''
          service = $('#hidden-zd-form #zd_description').data().service
          subject = $('#hidden-zd-form #zd_subject').data().value
          $('#hidden-zd-form #account_name').val name
          $('#hidden-zd-form #account_surname').val surname
          $('#hidden-zd-form #zd_name').val "#{name} #{surname}"
          $('#hidden-zd-form #zd_email').val email
          $('#hidden-zd-form #zd_phone').val phone
          $('#hidden-zd-form #zd_description').val "#{name} #{surname} ha richiesto un appuntamento telefonico per #{service} dalla pagina #{document.location.href} lasciando email, #{email}, e telefono, #{phone}"
          $('#hidden-zd-form #zd_subject').val "#{name} #{surname} #{subject}"
          $.ajax
            url: zd_form.data().action
            type: 'POST'
            data: zd_form.serialize()
            dataType: 'json'
            complete: ->
              $('#hidden-zd-form #zd_subject').val $('#hidden-zd-form #zd_subject').data().value
            success: (data)->
              appointment_form.append "<input type='hidden' name='ticket_id' value='#{data.ticket.id}' />"
              appointment_form.append "<input type='hidden' name='start_lead_email' value='#{data.lead_email}' />" if data.lead_email?
              appointment_form.data().sendZendesk = true
              appointment_form.trigger 'submit'
            error: ->
              $('#overlay').hide()
              alert 'Si è verificato un errore. Riprova più tardi.'
  # Fine check form per richiedere appuntamento

  $('iframe[src^="https://www.youtube.com/embed"]').each ->
    $(@).wrap('<span class="youtube-wapper">')

  # Aggiungo i data-label sulle tabelle negli articoli e setto la classe per farle responsive
  $('#content-single-post .desc-article table').each ->
    table = $(@)
    if table.find('thead').length > 0
      head = table.find('thead tr').first()
      table.addClass('table610') if head.find('th').length == 3
      head.find('th').each ->
        idx = $(@).index()+1
        txt = $(@).text().trim()
        if txt != ''
          $("tbody tr td:nth-child(#{idx})").data 'label', txt+":"
          $("tbody tr td:nth-child(#{idx})").attr 'data-label', txt+":"
    # Rimuovo le righe vuote
    table.find('tr').each ->
      $(@).remove() if $(@).text().trim() == '' and $(@).find('img').length == 0

  # Box condivisione
  $('.share-wrapper .share-link').on 'click', (event)->
    event.preventDefault()
    box = $(@).parent()
    if box.hasClass('open')
      box.removeClass('open')
    else
      box.addClass('open')

  $(".copy-button").addClass('clipboard')
  clipboard = new ClipboardJS '.copy-button', {
    text: (trigger)->
      trigger.getAttribute('data-url')
  }
  clipboard.on 'success', (e)->
    alert e.trigger.getAttribute('data-text')

# Nuova form commenti che passa da DEMO
$ ->
  if $('#demo_commentform[data-comment-sent="yes"]').length > 0
    alert('Commento inviato con successo!')
    url = remove_params_from_url(window.location.href, ['comment-sent'])
    document.location = url

  arr_phone1 = ["", ".", '390000000000', "000000000", "0000000000", "0000000000000", "1111", "11111", "111111111", "123123123", "123", "1234", "12345", "123456", "1234567", "123456778", "12345678", "123456789", "1234567890", "1234567899", "123456798", "222222222", "1234567891", "1324343123", "1787012", "213123123", "2323232323", "234234", "23456789", "39", "+39", "3213213213"]
  arr_phone2 = []
  $.each arr_phone1, (i,fmp)->
    arr_phone2.push "39"+fmp if $.inArray(fmp, ["",".","+39"]) == -1
  fake_mobile_phones = $.unique($.merge(arr_phone1,arr_phone2))
  phone_rg = /\+*([0-9\/\-\.\s]+){5,}/
  email_rg = /^([\w\.\-\+]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/

  $('#demo_commentform .field.required input').on 'change', ->
    if ($(@).attr('id') == 'mobile_phone' and (not phone_rg.test($(@).val()) or $.inArray($(@).val(), fake_mobile_phones) >= 0)) or $(@).val() == ''
      $(@).parents('.field').addClass('error')
    else if $(@).attr('id') == 'email' and not email_rg.test($(@).val())
      $(@).parents('.field').addClass('error')
    else
      $(@).parents('.field').removeClass('error')

  $('#demo_commentform .field.required textarea').on 'change', ->
    _val = $(@).val()
    if _val == ''
      $(@).parents('.field').addClass('error')
    else
      $(@).parents('.field').removeClass('error')
      # if /.*https?:\/\//.test(_val)
      #   $(@).parents('.field').addClass('error')
      #   alert 'Non puoi inserire dei link nel commento!'
      # else
      #   $(@).parents('.field').removeClass('error')

  $('#demo_commentform').on 'submit', (event)->
    $form = $(@)
    $form.find('.field.required').each ->
      field = $(@).find('input')
      field = $(@).find('textarea') if field.length == 0
      field.trigger('change')
    if $form.find('.field.error').length > 0 or $form.find('#email_confirmation').val() != ''
      if $form.find('.field.error #comment_content').length > 0 and $form.find('.field.error #comment_content').val() != ''
        if $form.find('.field.error').length == 1
          alert 'Non puoi inserire dei link nel commento!'
        else
          alert 'Non puoi inserire dei link nel commento!\nCompila tutti i campi obbligatori!'
      else
        alert 'Compila tutti i campi obbligatori!'
      event.preventDefault()
    else if $form.find('.cf-turnstile').length > 0 and not $form.find('input[name="cf-turnstile-response"]').val()
      alert 'Completa la verifica di sicurezza prima di inviare.'
      event.preventDefault()
# Fine nuova form commenti che passa da DEMO

$(window).on "scroll", ->
  # Posizione freccia che fa tornare ad inizio pagina
  if $(window).scrollTop() > $(window).height()
    _left = if $(window).width() > 1150 then Math.ceil(($(window).width() - 1150) / 2) else 10
    $("#scroll-top").css("left", "#{_left}px")
    $("#scroll-top").show()
  else
    $("#scroll-top").hide()

$(window).on "resize", ->
  w_window = $(window).width()

  move_submenu()

  _left = if w_window > 1150 then Math.ceil((w_window - 1150) / 2) else 10
  $("#scroll-top").css("left", "#{_left}px")

  fix_admin_bar_position()

  # Setto larghezza sottomenu Associazioni
  menu_ass = $("#menu-ass")
  if menu_ass.length > 0
    header_width = $("#header").outerWidth()
    menu_ass.css("width", "#{header_width}px")

  close_submenus(($('#menu-top-small').is(':visible') and $('#menu-top').is(':visible')), false)

  if w_window > 920
    $("#menu-top").removeAttr "style"

  # Sticky footer
  sticky_footer()

  if $('#menu-prontuario').hasClass('new-menu')
    if w_window <= 570
      $('#menu-prontuario .active').removeClass("active")
      $('#placeholder-tags').empty()
      $('#placeholder-posts').empty()
      $('#placeholder-tags, #placeholder-posts').hide()
      $('#wrap-cols').show()
    # else
    #   $('#placeholder-tags').css 'height', window.defaultHProntuario, 'display', 'inline-block'
    #   $('#placeholder-posts').css 'height', window.defaultHProntuario, 'display', 'inline-block'

$(document).on 'click', (event)->
  if $(event.target).parents('#menu-top').length == 0 and $(event.target).parents('#menu-ass').length == 0 and $(event.target).parents('#menu-top-small').length == 0 and $(event.target).attr('id') != 'menu-top-small' and $(event.target).parents('.children').length == 0
    close_submenus(true)

  if $(event.target).parents('.share-wrapper').length == 0 and $('.share-wrapper.open').length > 0
    $('.share-wrapper.open').removeClass('open')
